import { Modal, Button, Form } from "react-bootstrap";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

interface UserCountModalProps {
    show: boolean;
    onHide: () => void;
    companyId: string | number;
}

const UserCountModal: React.FC<UserCountModalProps> = ({ show, onHide, companyId }) => {
    const [userCount, setUserCount] = useState<string>("");
    const navigate = useNavigate();

    const handleProceed = () => {
        const count = Number(userCount);
        if (!count || isNaN(count) || count <= 0) {
            alert("Please enter a valid number of users.");
            return;
        }

        navigate(`/settings/company/upgrade-user/${companyId}?users=${count}`);
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Enter Number of Users</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={(e) => {
                    e.preventDefault(); // Prevent form reload
                    handleProceed();    // Call your logic
                }}>
                    <Form.Group controlId="userCountInput">
                        <Form.Label>Number of Users</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Enter number"
                            value={userCount}
                            onChange={(e) => setUserCount(e.target.value)}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleProceed}>
                    Proceed
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default UserCountModal;
